import React from 'react';
import { FormattedMessage } from 'react-intl';
import { quoteClicked } from '../presentation.utils';
import { AnimatedLink } from '../../components/animated-link/AnimatedLink';

import './presentation_banner.scss';
import '../quote_block.scss';

export class TailoredSearch extends React.Component<{}> {
  render() {
    return (
      <div className="presentation-banner__no_flex_border">
        <div className="banner-customers__block">
          <div className="presentation-banner__image_right">
            <img
              className="presentation-banner__image"
              src="/img/features/graphic-actu.png"
              alt="graphic-actu"
            />
          </div>
          <div className="presentation-banner__text_left">
            <h2 className="presentation-banner__title">
              <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/1" />
            </h2>
            <p className="banner-customers__subtitle">
              <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/2" />
            </p>

            <div>
              <p className="quote_block__citation_small">
                <em>
                  <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/3" />
                </em>
              </p>
              <img
                className="quote_block__picture"
                src="/img/home/martine_boyer_hemon.png"
                alt="martine_boyer_hemon"
              />
              <p className="quote_block__legend">
                <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/4" />
                <br />
                <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/5" />
              </p>
              <div className="quote_block__link">
                <AnimatedLink
                  onClick={() => quoteClicked('Martine Boyer-Hémon')}
                  className="quote_block__link"
                  href="/avis/martine-boyer-hemon"
                  source="home_public"
                  target="_blank"
                >
                  <FormattedMessage id="presentation/presentation-banner/TailoredSearch.tsx/6" />
                </AnimatedLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
